<app-header (found)="handleResults($event)"></app-header>
<div id="main-wrapper">
  <ngx-loading [show]="loadingDashboard" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <div class="main-background topSpace main-container clinicalContainer">
    <app-search-results [resultGridList]="data"></app-search-results>
    <div class="container-fluid dashboardView mt-4" style="padding: 0;">
      <div class="tab homeAccrordian row">

        <h1 class="carelon-page-title m-t-20">Clinical Communication</h1>
        <div class="">
          <div class="disclaimer page-sub-heading " #clinicalTableRef>Note: Information displayed here is based on the patient's visit to the CareMore Health Care
          Center. Please click on the flag symbol to view further details</div>
          <div class="clinicalCumm-info-alert">
            <div class="clinicla-info-header">
              <b>Attention</b>
            </div>
            <div style="padding-top: 9px;padding-bottom: 9px;">
              <span class="clinicalCumm-info-alert-text">
                For Clinical Data <b>prior to 6/10</b>, You can refer <b>Provider Portal</b>.
              </span>
              <br>
                <span class="clinicalCumm-info-alert-text">
                  For Encounter information <b>on or after 6/10</b>, kindly reach out to <b>Provider Relations</b>.
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="heading pull-left mainHeading col-md-3">Member Details</div>
            </div>
            <div class="col-md-12  col-xs-12  rightPad0 pad0 posRelative row m-t-20">
              <div class="col-md-6  col-xs-12 row">
                <div class="col-xs-5 col-md-6 form-group cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis filterByDuration pad0">
                  <label for="memberHealthPlan">FILTER BY DURATION</label>
                  <select class="form-select selectMenuOptions" [(ngModel)]="selectedduration" (change)="selectedDurationPeriod()" placeholder="FILTER BY DURATION">
                    <option value='7'>7 Days</option>
                    <option value='15'>15 Days</option>
                    <option value='30'>30 Days</option>
                    <option value='60'>60 Days</option>
                    <option value='90'>90 Days</option>
                    <option value='180'>180 Days</option>
                    <option value='365'>365 Days</option>
                  </select>
                </div>
                <div class="col-xs-7 form-group col-md-6 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis searchDropdown pad0"
                  style="position: relative;">
                  <div>
                    <label for="provider">SEARCH MEMBER NAME / ID / PCP</label>
                    <!-- <cup-autocomplete class="form-control input-underline" [colWidth]="16"
                    emptyMessage='No Providers Found' [autoCompleteDynamic]="true" [autoCompletePlaceholder]="">
                  </cup-autocomplete> -->
                  <!-- <input class="form-control input-underline" placeholder="Search any Member" [(ngModel)]="searchInput"
                  (ngModelChange)="filterMember($event)"> -->
                  <input class="form-control input-underline searchMember" style = "padding-left:10px;" placeholder="Search any Member / PCP"
                    [(ngModel)]="searchInput" (keyup)="filterMember($event)">
                  </div>
                </div>
              </div>
              <div class="col-md-6  col-xs-12 ">
                <div class="form-group col-md-8 rightPad0 pull-right">
                  <!-- <button class="btn green reportBtn" (click)=captureTable() [disabled]="notChecked" title="Select Members to Generate PDF">Generate PDF</button> -->
                  <div class="progressBarContainer">
                    <!--<p class="downloadText">Downloading..</p>-->
                    <!-- <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.1" [maximum]="1"  [speed]="200" [showSpinner]="true" [direction]="'rightToLeftIncreased'"
                  [color]="'#1b5b98'" [trickleSpeed]="250" [thick]="true" [ease]="'linear'"></ng-progress> -->
                </div>
                <button class="carelon-btn reportBtn generatePDFBtn" (click)=generatePdfOptions() [disabled]="notChecked" title="Click here to generate a consolidated PDF or individual PDF for selected member(s)">
                  Generate PDF for Selected Members
                </button>
              </div>
            </div>


          </div>
          <!--Mobile view starts -->

          <!-- Mobile view ends -->
          <div class="memberContainer dashboard-content mainClinicalTable clinicalDesktopTable">
            <table class="table custom-table myTable clinicalTable stcikyHeaders" id="myTable">
              <thead>
                <tr class="table-header stickyHeader">
                  <!-- <th>Index</th>-->
                  <!-- <th></th> -->
                  <th class="checkBoxContainer">SELECT TO <span class="nextLine">GENERATE PDF</span><div><input  type="checkbox"  [(ngModel)]='unselectFlag' class="custom-control-input checkboxinput" (change)="selectUnselectAll($event)" [ngStyle]="{'cursor': disableFlag ? 'not-allowed' : 'pointer'}" [disabled]="disableFlag"></div></th>
                  <th>MEMBER ID</th>
                  <th class="hidden-sm hidden-xs">MEMBER NAME</th>
                  <th class="hidden-sm hidden-xs">DATE OF BIRTH</th>
                  <th class="hidden-sm hidden-xs">Last Event Date</th>
                  <th class="hidden-sm hidden-xs">PCP</th>
                  <th class="hidden-sm hidden-xs">CLINICAL SUMMARY</th>
                  <th class="hidden-sm hidden-xs">ADMIT/DISCHARGE</th>
                  <th class="hidden-sm hidden-xs">MEDICATION CHANGE</th>
                </tr>
              </thead>
              <tbody class="panel">
                @for (memberDetails of virtualMemberDetailData ; track memberDetails; let rowIndex = $index) {
                  <ng-container
                    #someVar>
                    @if (memberDetails.memberHmoID) {
                      <tr class="accordion-toggle rows" data-toggle="collapse" [attr.data-target]="'#demo' + rowIndex"
                        data-parent="#myTable" (click)="getMemberId(memberDetails.memberId)" [attr.data-num]="rowIndex"
                        (click)="checkTableRow($event)" >
                        <!-- <td>{{rowIndex}}</td>-->
                        <!-- <td class="noPinters">{{memberDetails.memberId}}</td> -->
                        <td class="checkBoxContainer" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">
                          <input  type="checkbox" class="custom-control-input checkboxinput" #checkboxesPdf  value="{{memberDetails.memberHmoID}}" (change)="selectedMember(memberDetails, '', $event)">
                        </td>
                        <td class="noPinters" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">{{memberDetails.memberHmoID}}</td>
                        <td class="noPinters hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">{{memberDetails.memberFirstName+" "+memberDetails.memberLastName}}</td>
                        <td class="noPinters hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">{{memberDetails.memberDOB}}</td>
                        <td class="noPinters hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">{{memberDetails.mostRecentPatientSeenDate}}</td>
                        <td class="noPinters hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''">{{memberDetails.pcpName}}</td>
                        <td class="clinical relative hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''"
                          (click)="getPersonIdVal(memberDetails.memberId,memberDetails.memberHmoID);" id="clinicSummary5" align="center">
                          @if (!(memberDetails.clinicalFlag !='0')) {
                            <img  src = "../../../assets/images/icons/Flag_Disabled.svg">
                          }
                          @if ((memberDetails.clinicalFlag !='0')) {
                            <img (mouseover)="hoveringMethod(rowIndex)" (click)="enableFalgClicked(rowIndex)"  (mouseleave)="hoveringVal()"  class="enable" src = "../../../assets/images/icons/Flag_enabled.svg">
                          }
                          @if (hoveringRow == rowIndex && hovering && (memberDetails.clinicalFlag !='0')) {
                            <span
                            class="absolute hover-txt">Click here</span>
                          }</td>
                          <td align="center" class="admit relative hidden-sm hidden-xs" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''" (mouseover)="hoveringMethodInpatient(rowIndex)"
                            (mouseleave)="hoveringValInpatient()"
                            (click)="inpatientAdmissiondata(memberDetails);"
                            id="inpatient">
                            @if (!(memberDetails.hospitalCount !='0')) {
                              <img  src = "../../../assets/images/icons/Flag_Disabled.svg">
                            }
                            @if ((memberDetails.hospitalCount !='0')) {
                              <img  (click)="enableFalgClicked(rowIndex)" class="enable" src = "../../../assets/images/icons/Flag_enabled.svg">
                            }
                            @if (hoveringRow == rowIndex && hoveringIpatient && (memberDetails.hospitalCount !='0')) {
                              <span
                              class="absolute hover-txt">Click here</span>
                            }</td>
                            <td align="center" [ngClass]="rowIndex==currentTrIndex?'tdBgGreen':''" class="medication relative hidden-sm hidden-xs" (mouseover)="hoveringMethodMedication(rowIndex)"
                              (mouseleave)="hoveringValMedication()"
                              (click)="memberMedication(memberDetails.memberId,memberDetails.memberHmoID)"
                              id="medication">
                              @if (!(memberDetails.memberMedicationCount !='0')) {
                                <img  src = "../../../assets/images/icons/Flag_Disabled.svg">
                              }
                              @if ((memberDetails.memberMedicationCount !='0')) {
                                <img   class="enable" (click)="enableFalgClicked(rowIndex)"  src = "../../../assets/images/icons/Flag_enabled.svg">
                              }
                              @if (hoveringRow == rowIndex && hoveringMedication && (memberDetails.memberMedicationCount !='0')) {
                                <span
                                class="absolute hover-txt">Click here</span>
                              }</td>
                            </tr>
                          } @else {
                            <tr><td colspan="9">{{memberDetails}}</td></tr>
                          }
                          <tr id="{{ 'demo' +  rowIndex }}" class="collapse rows showRows innerRows parentTable parentTableForTabs">
                            <div class="col-xs-12 innerTableForTabs hideInDesktopView">
                              <!--admit/discharge mobile view starts-->
                              <div class="innerTableToShowMemberDetails memberDetailsTable">
                                <table>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">MEMBER NAME</th>
                                    <td>{{memberDetails.memberFirstName+" "+memberDetails.memberLastName}}</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">DATE OF BIRTH</th>
                                    <td>{{memberDetails.memberDOB}}</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">Last Event Date</th>
                                    <td>{{memberDetails.mostRecentPatientSeenDate}}</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">PCP</th>
                                    <td>{{memberDetails.pcpName}}</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">CLINICAL SUMMARY</th>
                                    <td class="clinical relative" (mouseover)="hoveringMethod(rowIndex)" (mouseleave)="hoveringVal()"
                                      (click)="getPersonIdVal(memberDetails.memberId,memberDetails.memberHmoID);" id="clinicSummary5" align="center"><i class="fa fa-flag"
                                      [ngClass]="(memberDetails.clinicalFlag !='0')?'enable':'disable'" title="Click here"><span class="viewDetails">View Details</span></i>@if (hoveringRow == rowIndex && hovering && (memberDetails.clinicalFlag !='0')) {
                                      <span
                                      class="absolute hover-txt">Click here</span>
                                    }</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">ADMIT/DISCHARGE</th>
                                    <td align="center" class="admit relative" (mouseover)="hoveringMethodInpatient(rowIndex)"
                                      (mouseleave)="hoveringValInpatient()"
                                      (click)="inpatientAdmissiondata(memberDetails);"
                                      id="inpatient"><i class="fa fa-flag"
                                      [ngClass]="(memberDetails.hospitalCount !='0')?'enable':'disable'" title="Click here"><span class="viewDetails">View Details</span></i>@if (hoveringRow == rowIndex && hoveringIpatient && (memberDetails.hospitalCount !='0')) {
                                      <span
                                      class="absolute hover-txt" >Click here</span>
                                    }</td>
                                  </tr>
                                  <tr>
                                    <th class="small text-muted pr-2" scope="row">MEDICATION CHANGE</th>
                                    <td align="center" class="medication relative" (mouseover)="hoveringMethodMedication(rowIndex)"
                                      (mouseleave)="hoveringValMedication()"
                                      (click)="memberMedication(memberDetails.memberId,memberDetails.memberHmoID)"
                                      id="medication"><i class="fa fa-flag "
                                      [ngClass]="(memberDetails.memberMedicationCount !='0')?'enable':'disable'" title="Click here"><span class="viewDetails">View Details</span></i>@if (hoveringRow == rowIndex && hoveringMedication && (memberDetails.memberMedicationCount !='0')) {
                                      <span
                                      class="absolute hover-txt">Click here</span>
                                    }</td>
                                  </tr>
                                </table>
                                @if ((memberDetails.hospitalCount == 0 && memberDetails.memberStatusCount == 0 && memberDetails.memberMedicationCount == 0 && memberDetails.clinicalFlag == 0)) {
                                  <div class="noContent"
                                    align="center"  width="100%">
                                    No clinical communications for this member.
                                  </div>
                                }
                              </div>
                              <!--ends-->
                            </div>
                            <td class="innerTableToShowMemberDetails hidden-sm hidden-xs">
                            </td>
                            @if ((memberDetails.hospitalCount == 0 && memberDetails.memberStatusCount == 0 && memberDetails.memberMedicationCount == 0 && memberDetails.clinicalFlag == 0)) {
                              <td class="noContent"
                                colspan="10" align="center"  width="100%">
                                No clinical communications for this member.
                              </td>
                            }
                            @if ((memberDetails.hospitalCount != 0 || memberDetails.memberStatusCount != 0 || memberDetails.memberMedicationCount != 0 || memberDetails.clinicalFlag !=0)) {
                              <td
                                colspan="10" class="hiddenRow noContent setMobileWidth">
                                <div class="closeBtn pull-right"><button class="btn-link bg-white" (click)="closeExpandedRow()"><img src = "../../../assets/images/Close.svg"></button>
                              </div>
                              <ul class="nav nav-tabs clinicalTabsList" id="myTab" role="tablist">
                                <li class="clinicalLi" [ngClass]="{'active': clinicalActive}">
                                  <a class="nav-link" id="clinicalSummary-tab" data-toggle="tab"
                                    role="tab" aria-controls="clinicalSummary"
                                  aria-selected="false" (click)="getPersonIdVal(memberId,memberDetails.memberHmoID)">Clinical Summary</a>
                                </li>
                                <li class="admitLi" [ngClass]="{'active': admitDischargeActive}">
                                  <a class="nav-link" id="inpatientAdmission-tab" data-toggle="tab"
                                    role="tab" aria-controls="inpatientAdmission"
                                  aria-selected="false" (click)="inpatientAdmissiondata(memberDetails);">Admit/Discharge </a>
                                </li>
                                <li class="medicationLi" [ngClass]="{'active': medicationChangeActive}">
                                  <a class="nav-link" id="medication-tab" data-toggle="tab"
                                    role="tab" aria-controls="medication" aria-selected="false"
                                  (click)="memberMedication(memberId,memberDetails.memberHmoID);">Medication Change</a>
                                </li>
                              </ul>
                              <div class="tab-content" id="myTabContent">
                                <div class="tab-pane" [ngClass]="{'active in': clinicalActive}"
                                  id="clinicalSummary-{{rowIndex}}" role="tabpanel"
                                  aria-labelledby="clinicalSummary-tab">
                                  <!-- Clinical summary mobile view starts here-->
                                  <!-- Clinical summary mobile view ends here-->
                                  @if (clinicalSummaryLoading) {
                                    <div class="noClinicaldata">
                                      <img class="loader-symbol" src="../../assets/images/loading.gif">
                                    </div>
                                  } @else {
                                    @if (formattedDateTime.length > 0) {
                                      <div class="form-group text-left clinicalNoLoadingDiv">
                                        @if (aips.length !== 0) {
                                          <div>
                                            <button class=" carelon-btn reportBtn pull-right generateAdmitPDFBtn"
                                            (click)="clinicalSummaryPDF(memberDetails)" [disabled]="aips.length === 0" >Generate Clinical Summary PDF</button>
                                          </div>
                                        }
                                        <div>
                                          <table class="reasonForVisitTable" style="border: none;">
                                            @if (formattedDateTime.length > 0) {
                                              <tr>
                                    <th class="reasonForVisitHead" style="background: none;
                                    border-top: none;border-bottom: none; text-align: left;">
                                                  <span class="clinical-summary-heading-label">Encounter Date & Time : </span>
                                                  <span class="clinical-summary-heading-label">Please select </span>
                                                  <span class="dBlock clinical-summary-sub-heading-label">Encounters are listed in Pacific Time</span>
                                                </th>
                                                <td class="reasonForVisitData" style="border-right: none;border-top: none;text-align: left;">
                                                  <select class="form-select clinical-summary-heading-value encounterDateOptions" [(ngModel)]="encounterDate" (change)="encounterDateChange()" style="margin-left:0">
                                                    @for (date of formattedDateTime; track date; let i = $index) {
                                                      <option [value] ="date" >{{date}}</option>
                                                    }
                                                  </select>
                                                </td>
                                              </tr>
                                            }
                                            <tr>
                                    <th class="reasonForVisitHead clinical-summary-heading-label "  style="background: none;
                                    border-top: none;
                                    border-bottom: none; text-align: left;"> Provider/Clinician seen :</th>
                                    <td class="reasonForVisitData clinical-summary-heading-value" style="border-right: none;
                                    border-top: none;text-align: left;"><span>{{providerName}}</span></td>
                                              </tr>
                                              <tr>
                                    <th class="reasonForVisitHead clinical-summary-heading-label" style="background: none;
                                    border-top: none;
                                    border-bottom: none; text-align: left;">Visit Type :</th>
                                    <td class="reasonForVisitData clinical-summary-heading-value" style="border-right: none;
                                    border-top: none;text-align: left;">Office Visit</td>
                                              </tr>
                                              <tr>
                                    <th class="reasonForVisitHead clinical-summary-heading-label" style="background: none;
                                    border-top: none;
                                    border-bottom: none; text-align: left;">Reason For Visit :</th>
                                    <td class="reasonForVisitData clinical-summary-heading-value" style="border-right: none;
                                    border-top: none;text-align: left;"><span class="info">{{reasonForVisit}}</span></td>
                                                </tr>
                                                <tr>
                                    <th class="reasonForVisitHead clinical-summary-heading-label" style="background: none;
                                    border-top: none;
                                    border-bottom: none; text-align: left;">Location Name :</th>
                                    <td class="reasonForVisitData clinical-summary-heading-value" style="border-right: none;
                                    border-top: none;text-align: left;"><span class="info">{{locationName}}</span></td>
                                                  </tr>
                                                  <tr>
                                    <th class="reasonForVisitHead clinical-summary-heading-label" style="background: none;
                                    border-top: none;
                                    border-bottom: none; text-align: left;">Event :</th>
                                    <td class="reasonForVisitData clinical-summary-heading-value" style="border-right: none;
                                    border-top: none;text-align: left;"><span class="info">{{eventName}}</span></td>
                                                    </tr>
                                                  </table>
                                                </div>
                                              </div>
                                            }
                                            <div class="col-md-12 clinicalInfo">
                                              @if (aips.length > 0) {
                                                <div>
                                                  <!-- <div class="heading innerHeading visitContent">Visit Type-
                                                  <span>{{ClinicalSummaryData.VisitType}}</span></div>
                                                  <div class="heading innerHeading visitContent">EncounterDate:
                                                    <span>{{ClinicalSummaryData.EncounterDate}}</span></div> -->
                                                    <div class="accordian-section">
                                                      <p-accordion
                                                        >
                                                        <p-accordionTab  class="color-r"
                                                          [ngClass]="{'color-g': disease?.metAverage > disease?.averagePercentage}" >
                                                          <p-header  style="width:100%">
                                                            <div class="acc-header">
                                                              <div class="acc-content-label"> Assessment / Plan</div>
                                                            </div>
                                                          </p-header>
                                                          <div class="accordian-table-section">
                                                            <div class="table-wrapper-scroll-y">
                                                              <table class="table custom-table tableShadow stcikyHeaders" id="clinicalTableAssestment">
                                                                <thead class="hideInMobile">
                                                                  <tr class="table-header">
                                                                    <th>Detail Type Priority</th>
                                                                    <th>DETAIL TYPE</th>
                                                                    <th>DESCRIPTION </th>
                                                                    <!-- <th>DxCode</th> -->
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  @for (ClinicalSummaryAip of aips | paginate: { itemsPerPage: noOfItems, currentPage: p }; track ClinicalSummaryAip) {
                                                                    @if (ClinicalSummaryAip.DetailTypePriority) {
                                                                      <tr class="flexColumn preTable">
                                                                        <th>Detail Type Priority</th>@if (ClinicalSummaryAip.DetailTypePriority || ClinicalSummaryAip.DetailTypePriority == '') {
                                                                        <td
                                                                          >
                                                                        {{ClinicalSummaryAip.DetailTypePriority}}</td>
                                                                      }
                                                                      <th>DETAIL TYPE</th>@if (ClinicalSummaryAip.DetailType || ClinicalSummaryAip.DetailType == '') {
                                                                      <td
                                                                        >
                                                                      {{ClinicalSummaryAip.DetailType}}</td>
                                                                    }
                                                                    <th>DESCRIPTION </th>@if (ClinicalSummaryAip.Description || ClinicalSummaryAip.Description == '') {
                                                                    <td
                                                                      >
                                                                    {{ClinicalSummaryAip.Description}}</td>
                                                                  }
                                                                  <!-- <td *ngIf="ClinicalSummaryAip.DxCode || ClinicalSummaryAip.DxCode == ''">
                                                                {{ClinicalSummaryAip.DxCode}}</td> -->
                                                              </tr>
                                                            } @else {
                                                              <td colspan="4">{{ClinicalSummaryAip}}</td>
                                                            }
                                                          }
                                                          <tr align="center" class="paginationTab clinicalPaging">
                                                            <td colspan="9">
                                                              <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </p-accordionTab>
                                              </p-accordion>
                                            </div>
                                            <div class="mt-3 accordian-section">
                                              <p-accordion
                                                >
                                                <p-accordionTab  class="color-r m-t-20"
                                                  >
                                                  <p-header  style="width:100%">
                                                    <div class="acc-header">
                                                      <div class="acc-content-label"> Vital Signs</div>
                                                    </div>
                                                  </p-header>
                                                  <div class="accordian-table-section">
                                                    <div class="table-wrapper-scroll-y" id="">
                                                      <table class="table custom-table tableShadow stcikyHeaders">
                                                        <thead class="hideInMobile">
                                                          <tr class="table-header">
                                                            <th>Time</th>
                                                            <th>BP (mm/Hg)</th>
                                                            <th>PULSE/min</th>
                                                            <th>RESP/min</th>
                                                            <th>TEMPERATURE (f)</th>
                                                            <th>HEIGHT (ft)</th>
                                                            <th>WEIGHT (lb)</th>
                                                            <th>WEIGHT %</th>
                                                            <th>BMI kg/m2</th>
                                                            <th>BMI %</th>
                                                            <th>BSA m2</th>
                                                            <th>O2 Sat%</th>
                                                            <th>PAIN SCORE</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          @for (ClinicalSummaryDataVitals of vitals; track ClinicalSummaryDataVitals) {
                                                            @if (ClinicalSummaryDataVitals.Time) {
                                                              <tr  class="flexColumn preTable clinicalVisitTypeInfo">
                                                                <th>Time</th><td><span class="heading1">Time</span><span>{{ClinicalSummaryDataVitals.Time}}</span></td>
                                                                <th>BP (mm/Hg)</th><td><span class="heading1">BP (mm/Hg)</span><span>{{ClinicalSummaryDataVitals.BP}}</span></td>
                                                                <th>PULSE/min</th><td><span class="heading1">PULSE/min</span><span>{{ClinicalSummaryDataVitals.PulseRate}}</span></td>
                                                                <th>RESP/min</th><td><span class="heading1">RESP/min</span><span>{{ClinicalSummaryDataVitals.Respiration}}</span></td>
                                                                <th>TEMPERATURE (f)</th><td><span class="heading1">TEMPERATURE (f)</span><span>{{ClinicalSummaryDataVitals.TempF}}</span></td>
                                                                <th>HEIGHT (ft)</th><td><span class="heading1">HEIGHT (ft)</span><span>{{ClinicalSummaryDataVitals.HeightFt}}</span></td>
                                                                <th>WEIGHT (lb)</th><td><span class="heading1">WEIGHT (lb)</span><span>{{ClinicalSummaryDataVitals.WeightLb}}</span></td>
                                                                <th>WEIGHT %</th><td><span class="heading1">WEIGHT %</span><span>{{ClinicalSummaryDataVitals.WeightPercent}}</span></td>
                                                                <th>BMI kg/m2</th><td><span class="heading1">BMI kg/m2</span><span>{{ClinicalSummaryDataVitals.BMICalc}}</span></td>
                                                                <th>BMI %</th><td><span class="heading1">BMI %</span><span>{{ClinicalSummaryDataVitals.BMIPercent}}</span></td>
                                                                <th>BSA m2</th><td><span class="heading1">BSA m2</span><span>{{ClinicalSummaryDataVitals.BSA}}</span></td>
                                                                <th>O2 Sat%</th><td><span class="heading1">O2 Sat%</span><span>{{ClinicalSummaryDataVitals.SPo2}}</span></td>
                                                                <th>PAIN SCORE</th><td><span class="heading1">PAIN SCORE</span><span>{{ClinicalSummaryDataVitals.PainScore}}</span></td>
                                                              </tr>
                                                            } @else {
                                                              <td colspan="13">{{ClinicalSummaryDataVitals}}</td>
                                                            }
                                                          }
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </p-accordionTab>
                                              </p-accordion>
                                            </div>
                                          </div>
                                        } @else {
                                          <div class="noClinicaldata">No clinical events exist for the selected type, member and date</div>
                                        }
                                      </div>
                                    }
                                  </div>
                                  <div class="tab-pane fade admitRow row" [ngClass]="{'show active': admitDischargeActive}"
                                    id="inpatientAdmission-{{rowIndex}}" role="tabpanel" aria-labelledby="inpatientAdmission-tab">
                                    @if (inPatientData && inPatientData[0] !== 'No clinical events exist for the selected type, member and date') {
                                      <div class="col-md-12 d-flex justify-content-end">
                                        <button class="btn btn-primary float-end" (click)="admitDischargePDF(memberDetails)" title="Select Members to Generate PDF">
                                          Generate Admit/Discharge PDF
                                        </button>
                                      </div>
                                    }
                                    <div class="col-md-12">
                                      <div class="my-custom-scrollbar">
                                        <table class="table" id="inpatientAdmissionTable">
                                          <thead class="">
                                            <tr>
                                              <th>SERVICE AUTHORIZATION NO</th>
                                              <th>ADMIT DATE</th>
                                              <th>DISCHARGE DATE</th>
                                              <th>ADMITTED FACILITY</th>
                                              <th>MORE INFO</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            @if (admitDischardeLoading) {
                                              <tr>
                                                <td colspan="6" class="text-center">
                                                  <img class="loader-symbol" src="../../assets/images/loading.gif">
                                                </td>
                                              </tr>
                                            } @else {
                                              @for (inpatient of inPatientData; track inpatient; let i = $index) {
                                                @if (inpatient?.memberAdmitDate) {
                                                  @if (i == 0) {
                                                    <tr class="">
                                                      <td>{{inpatient.serviceAuthorization}}</td>
                                                      <td>{{inpatient.memberAdmitDate}}</td>
                                                      <td>{{inpatient.memberDischargeDate}}</td>
                                                      <td>{{inpatient.admittedfacility}}</td>
                                                      <td (click)="inpatientCollapse()">
                                                        @if (!inpatientClose) {
                                                          <span class="cursor-pointer iconSize">
                                                            <i class="fa fa-plus"></i>
                                                          </span>
                                                        }
                                                        @if (inpatientClose) {
                                                          <span class="iconSize">
                                                            <i class="fa fa-close"></i>
                                                          </span>
                                                        }
                                                      </td>
                                                    </tr>
                                                  }
                                                } @else {
                                                  <td colspan="6">{{inpatient}}</td>
                                                }
                                              }
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    @for (inpatient of inPatientData; track inpatient) {
                                      <div id="inpatCollap"
                                        [ngClass]="inpatCollapDisplay ? 'd-block' : 'd-none'" class="admitDischargeContainer">
                                        @if (inpatient?.memberAdmitDate;) {
                                          <div class="inPatientData-display">
                                            @if (inpatient.inpatientdetailcategory === 'Admitting Physician') {
                                              <div>
                                                <table class="table  table-bordered">
                                                  <tbody>
                                                    <tr class="tableBodytr">
                                                      <td style="width: 50%; color: #23499E !important;">{{inpatient.inpatientdetailcategory}}</td>
                                                      <td style="font-weight: bold !important;">{{inpatient.inpatientdetails}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            }
                                            @if (inpatient.inpatientdetailcategory === 'Discharging Extensivist') {
                                              <div>
                                                <table class="table table-bordered">
                                                  <tbody>
                                                    <tr class="tableBodytr">
                                                      <td style="width: 50%; color: #23499E !important;">{{inpatient.inpatientdetailcategory}}</td>
                                                      <td style="font-weight: bold !important;">{{inpatient.inpatientdetails}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            }
                                            @if (inpatient.inpatientdetailcategory.trim() === 'Admitting Diagnosis') {
                                              <div >
                                                <table class="table table-bordered">
                                                  <tbody>
                                                    <tr class="tableBodytr">
                                                      <td style="width: 50%; color: #23499E !important;">{{inpatient.inpatientdetailcategory}}</td>
                                                      <td style="font-weight: bold !important;">{{inpatient.inpatientdetails}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            }
                                            @if (inpatient.inpatientdetailcategory === 'Discharge Diagnosis' || inpatient.inpatientdetailcategory === 'DischargeDiagnosis') {
                                              <div >
                                                <table class="table table-bordered">
                                                  <tbody>
                                                    <tr class="tableBodytr">
                                                      <td style="width: 50%; color: #23499E !important;">{{inpatient.inpatientdetailcategory}}</td>
                                                      <td style="font-weight: bold !important;">{{inpatient.inpatientdetails}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            }
                                            @if (inpatient.inpatientdetailcategory === 'Discharge Procedure' || inpatient.inpatientdetailcategory === 'DischargeProcedure') {
                                              <div class="my-custom-scrollbar">
                                                <table class="table table-bordered">
                                                  <tbody>
                                                    <tr class="tableBodytr">
                                                      <td class="">{{inpatient.inpatientdetailcategory}}</td>
                                                      <td>{{inpatient.inpatientdetails}}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                    <div [ngClass]="inpatCollapDisplay ? 'd-block' : 'd-none'" class="d-flex flex-wrap">
                                      @if (documentsList.length > 0) {
                                        <div class="row">
                                          @for (each of documentsList; track each) {
                                            <div class="col-sm-4 col-md-12 p-3">
                                              <span aria-hidden="true" class="doc-icon" (click)="getDocument(each)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                  <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                                </svg>
                                                <span style="margin-top: 6px; margin-left: 6px;">
                                                  <a class="doc-list-name" [title]="each?.DocumentTitle">{{each?.DocumentTitle}}</a>
                                                </span>
                                              </span>
                                            </div>
                                          }
                                        </div>
                                      }
                                      @if (documentsList.length == 0) {
                                        <div class="noClinicaldataSection">
                                          <p class="noClinicaldata">Discharge Summary is not yet available. It is expected within two business days of hospital discharge.</p>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <div class="tab-pane" [ngClass]="{'active in': medicationChangeActive}"
                                    id="medication-{{rowIndex}}" role="tabpanel"
                                    aria-labelledby="medication-tab">
                                    @if (memberMedicationData && memberMedicationData[0] !=='No Data found for the time duration') {
                                      <div>
                                        <button class=" carelon-btn reportBtn pull-right generateAdmitPDFBtn" (click)=medicationChangePDF(memberDetails)  >Generate Medication Change PDF</button>
                                      </div>
                                    }
                                    <!--Medication change mobile view starts-->
                                    <!--medication mobile view ends-->
                                    <!--IE fixed headers starts-->
                                    <div class="accordion-info fixed-height table-scroll iefixedTableHeader tableFullView" >
                                      <table class="table custom-table fixed-height table-scroll fixedLayout hideInMobile" >
                                        <thead></thead>
                                        <tbody>
                                          <tr class="table-header hideInMobile">
                                            <td style="width: 5em">PRESCRIPTION START DATE</td>
                                            <td style="width: 5em">PRESCRIPTION END DATE</td>
                                            <td style="width: 5em">MEDICATION NAME</td>
                                            <td style="width: 4em">QUANTITY</td>
                                            <td style="width: 5em">NUMBER OF REFILLS</td>
                                            <td style="width: 7em">STATUS</td>
                                            <td style="width: 5em">PRESCRIBER NAME</td>
                                            <td style="width: 8em">NOTES</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <!-- ends-->
                                    <div class="table-wrapper-scroll-y my-custom-scrollbar ieFix tableFullView">
                                      <table class="table custom-table tableShadow stcikyHeaders fixedLayout pagingTable">
                                        <thead class="hideInMobile">
                                          <tr class="table-header">
                                            <th style="width: 11em">PRESCRIPTION START DATE</th>
                                            <th style="width: 8em">PRESCRIPTION END DATE</th>
                                            <th style="width: 9em">MEDICATION NAME</th>
                                            <th style="width: 6em">QUANTITY</th>
                                            <th style="width: 6em">NUMBER OF REFILLS</th>
                                            <th style="width: 8em">STATUS</th>
                                            <th style="width: 8em">PRESCRIBER NAME</th>
                                            <th style="width: 11.8em">NOTES</th>
                                          </tr>
                                        </thead>
                                        <tbody class="medicatioChangeTbody">
                                          @if (medicationLoading) {
                                            <tr>
                                              <td colspan="6" class="text-center-loading">
                                                <img class="loader-symbol" src="../../assets/images/loading.gif">
                                              </td>
                                            </tr>
                                          } @else {
                                            <!-- <ng-container
                                            *ngFor="let medicationData of memberMedicationData | dateFormatPipe:oneWeekdate():todaydate():'medication'"> -->
                                            @for (medicationData of memberMedicationData; track medicationData) {
                                              <ng-container class="tbody-Content" class="mediDesktop">
                                                @if (medicationData?.medicationPrescriptionDate) {
                                                  <tr class="flexColumn preTable">
                                                    <th>PRESCRIPTION START DATE</th><td>{{medicationData.medicationStartDate}}</td>
                                                    <th>PRESCRIPTION END DATE</th><td>{{medicationData.medicationStopDate}}</td>
                                                    <th>MEDICATION NAME</th><td>{{medicationData.medicationName}}</td>
                                                    <th>QUANTITY</th><td>{{medicationData.medicationQuantity}}</td>
                                                    <th>NUMBER OF REFILLS</th><td>{{medicationData.medicationRefills}}</td>
                                                    <th>STATUS</th><td>{{medicationData.status}}</td>
                                                    <th>PRESCRIBER NAME</th><td>{{medicationData.prescriberName}}</td>
                                                    <th>NOTES</th><td>{{medicationData.medicationNotes}}</td>
                                                  </tr>
                                                } @else {
                                                  <td colspan="6">{{medicationData}}</td>
                                                }
                                              </ng-container>
                                            }
                                            <!--  <ng-container *ngFor="let medicationData of memberMedicationData | paginate: { itemsPerPage: 1, currentPage: p }" class="mediMobile">
                                            <tr *ngIf="medicationData?.medicationPrescriptionDate; else noMedData" class="flexColumn mediMobile">
                                              <th>PRESCRIPTION START DATE</th><td>{{medicationData.medicationStartDate}}</td>
                                              <th>PRESCRIPTION END DATE</th><td>{{medicationData.medicationStopDate}}</td>
                                              <th>MEDICATION NAME</th><td>{{medicationData.medicationName}}</td>
                                              <th>QUANTITY</th><td>{{medicationData.medicationQuantity}}</td>
                                              <th>NUMBER OF REFILLS</th><td>{{medicationData.medicationRefills}}</td>
                                              <th>STATUS</th><td>{{medicationData.status}}</td>
                                              <th>PRESCRIBER NAME</th><td>{{medicationData.prescriberName}}</td>
                                              <th>NOTES</th><td>{{medicationData.medicationNotes}}</td>
                                            </tr>
                                            <div align="left" class="mediMobile paginationTab"><pagination-controls (pageChange)="p = $event"></pagination-controls></div>
                                            <ng-template #noMedData>
                                              <td colspan="1">{{medicationData}}</td>
                                            </ng-template>
                                          </ng-container>-->
                                        }
                                      </tbody>
                                    </table>
                                    <!--<button class="moreMedication pull-right" (click)="toggleMoreMedication()">{{buttonName}}</button>
                                    <div class="moreMedicationTable" *ngIf="showMedication">
                                      <table class="table custom-table tableShadow">
                                        <thead>
                                          <tr class="table-header">
                                            <th>PRESCRIPTION START DATE</th>
                                            <th>PRESCRIPTION END DATE</th>
                                            <th>MEDICATION NAME</th>
                                            <th>QUANTITY</th>
                                            <th>NUMBER OF REFILLS</th>
                                            <th>STATUS</th>
                                            <th>PRESCRIBER NAME</th>
                                            <th>NOTES</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *ngIf="loading; else noLoading">
                                            <tr>
                                              <td colspan="6" class="text-center-loading">
                                                <img class="loader-symbol" src="../../assets/images/loading.gif">
                                              </td>
                                            </tr>
                                          </ng-container>
                                          <ng-template #noLoading>
                                            <ng-container
                                              *ngFor="let medicationData of memberMedicationData | dateFormatPipe:oneWeekdate():todaydate():'medication'">
                                              <ng-container *ngFor="let medicationData of memberMedicationData"> -->
                                                <!--<tr *ngIf="medicationData?.medicationPrescriptionDate; else noMedData">
                                                <td>{{medicationData.medicationPrescriptionDate}} </td>
                                                <td>End date </td>
                                                <td>{{medicationData.medicationName}}</td>
                                                <td>{{medicationData.medicationQuantity}}</td>
                                                <td>{{medicationData.medicationRefills}}</td>
                                                <td>Active</td>
                                                <td>{{medicationData.prescriberName}}</td>
                                                <td>{{medicationData.medicationNotes}}</td>
                                              </tr>
                                              <ng-template #noMedData>
                                                <td colspan="6">{{medicationData}}</td>
                                              </ng-template>
                                            </ng-container>
                                          </ng-template>
                                        </tbody>
                                      </table>
                                    </div>-->
                                  </div>
                                  @if (numberOfPages > 1) {
                                    <div class="tRight mediMobile pageContainer">
                                      <a class="previous" (click)="clickPrevious()">Previous</a>
                                      <a class="next"  (click)="clickNext()">Next</a>
                                      <input type="hidden" id="hdnActivePage" value="1" />
                                    </div>
                                  }
                                </div>
                              </div>
                            </td>
                          }
                        </tr>
                      </ng-container>
                    }
                  </tbody>
                </table>
              </div>
              <div align="center" class="viewMoreBtn">
                <div colspan="9">
                  <button id="display" (click)="loadmore()" class="viewMoreDisplay regularViewMore">View More</button>
                  <!-- <button id="searchInputDisplay" class="viewMoreDisplay searchInputViewMore">View More</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <div class="modal fade memberModal" id="generatePdf" role="dialog">
      <div class="modal-dialog" style="margin-top: 15%;">
        <div class="modal-content">
          <div class="modal-header no-border">
            <button type="button" class="btn-close op-1-0" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p class="text-center margin0">Please select a format to generate PDF for selected member(s) </p>
          </div>
          <div class="modal-footer no-border" style="justify-content: center">
            <div class="container-contact100-form-btn">
              <button type="button" class="carelon-btn" style="margin-right: 4px !important;" (click)="captureTable('multiple')" data-bs-dismiss="modal" title="PDF for all selected member(s).">Single PDF</button>
              <button type="button" class="carelon-btn" (click)="captureTable('single')" data-bs-dismiss="modal" title="PDF(s) for each selected member.">Multiple PDF</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade memberModal" id="pdfInfo" role="dialog">
      <div class="modal-dialog" style="margin-top: 15%;">
        <div class="modal-content">
          <div class="modal-header  no-border">
            <button type="button" class="btn-close op-1-0" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            @if (clinicalPDFinfo) {
              <p class="text-center margin0">Clinical Summary PDF for the selected member downloaded. Please check.</p>
            }
            @if (admitDischargePDFinfo) {
              <p class="text-center margin0">Admit/Discharge PDF for the selected member downloaded. Please check.</p>
            }
            @if (medicationChangePDFinfo) {
              <p class="text-center margin0">Medication Change PDF for the selected member downloaded. Please check.</p>
            }
          </div>
          <div class="modal-footer no-border d-flex justify-content-center">
            <div class="container-contact100-form-btn">
              <button type="button" class="carelon-btn" data-bs-dismiss="modal" title="Ok">Ok</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade memberModal" id="errorGeneratePdf" role="dialog">
      <div class="modal-dialog" style="margin-top: 15%;">
        <div class="modal-content">
          <div class="modal-header no-border">
            <button type="button" class="btn-close op-1-0" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p class="text-center margin0">We are experiencing technical difficulties. To report the error please contact Provider Relations
            at (888) 291-1358 option 3, then option 5.</p>
          </div>
          <div class="modal-footer no-border d-flex justify-content-center">
            <div class="container-contact100-form-btn">
              <button type="button" class="carelon-btn" (click)="errorModal()" data-bs-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>